import { render } from "./TheCardOff.vue?vue&type=template&id=055b0fb4"
const script = {}

import "./TheCardOff.vue?vue&type=style&index=0&id=055b0fb4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__